export * from "./types/RPCEnum"
export * from "./types/RPCRequest"
export * from "./types/RPCResponse"

import { EncodeJWT } from "@pdfking/tfunc"

import type { RPCRequest } from "./types/RPCRequest"

export type RemoteServerConfig = {
  secret: string
  url: string
  db: string
}

export const EncodeServerJWT = async (
  rpc: RPCRequest,
  { secret, url }: RemoteServerConfig
) => {
  const target = url || "https://localhost:2100"
  const token = await EncodeJWT(rpc, secret)
  return `${target}/${token}`
}
